// app/javascript/controllers/inline_edit_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "error"]

    async save(event) {
        try {
            const response = await this.submitForm()

            if (response.ok) {
                const data = await response.json()

                if (data.triggered_fields) {
                    this.updateTriggeredFields(data.triggered_fields)
                }
            } else {
                const error = await response.json()
                this.showError(error.message)
            }
        } catch (error) {
            this.showError("An error occurred while saving")
        }
    }

    async submitForm() {
        const formData = new FormData(this.formTarget)

        return fetch(this.formTarget.action, {
            method: this.formTarget.method,
            body: formData,
            headers: {
                "Accept": "application/json"
            }
        })
    }

    showError(message) {
        this.errorTarget.textContent = message
        this.errorTarget.classList.remove("hidden")
    }

    updateTriggeredFields(fields) {
        Object.entries(fields).forEach(([field, value]) => {
            const element = document.querySelector(`[data-field="${field}"]`)
            if (element) {
                element.textContent = value
            }
        })
    }
}